<script lang="ts">
  import { RiEyeFill, RiEyeOffFill } from "svelte-remixicon"

  export let value: string
  export let name: string
  export let placeholder: string

  let passwordOrText = "password"

  const togglePasswordOrText = () => {
    passwordOrText = passwordOrText === "password" ? "text" : "password"
  }
</script>

<div class="relative">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div on:click={togglePasswordOrText} class="absolute z-50 right-0 top-1/2 -translate-y-1/2 -translate-x-4 cursor-pointer">
    {#if passwordOrText === "password"}
      <RiEyeFill />
    {:else}
      <RiEyeOffFill />
    {/if}
  </div>
  {#if passwordOrText === "password"}
    <input on:focus type="password" {name} {placeholder} class="form-field-ai w-full" bind:value={value} />
  {:else if (passwordOrText === "text")}
    <input on:focus type="text" {name} {placeholder} class="form-field-ai w-full" bind:value={value} />
  {/if}
</div>